import {HttpContextToken, HttpErrorResponse} from '@angular/common/http';

// Only documented errors with explicit request opt-in may use local recovery UI.
import {domainErrorStatuses} from './domain-error-statuses';
import {LocalApiErrorCode} from './local-api-error-code';
export type {LocalApiErrorCode} from './local-api-error-code';

export const LOCALLY_HANDLED_API_ERROR_CODES = new HttpContextToken<readonly LocalApiErrorCode[]>(() => []);
const presentedSystemErrors = new WeakSet<object>();

export function markSystemApiErrorPresented(error: object): void { presentedSystemErrors.add(error); }
export function wasSystemApiErrorPresented(error: unknown): boolean {
  return !!error && typeof error === 'object' && presentedSystemErrors.has(error);
}

export function isLocallyHandledApiError(error: unknown, allowedCodes: readonly LocalApiErrorCode[]): boolean {
  if (!(error instanceof HttpErrorResponse) || !error.error || typeof error.error !== 'object') return false;
  if (allowedCodes.includes('VALIDATION_ERROR') && isModelBindingValidationError(error)) return true;
  const payload = error.error as {success?: unknown; error?: {code?: unknown; message?: unknown}};
  if (payload.success !== false || !payload.error || typeof payload.error !== 'object') return false;
  const {code, message} = payload.error;
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(domainErrorStatuses, code)
    && domainErrorStatuses[code as LocalApiErrorCode] === error.status
    && typeof message === 'string' && message.trim().length > 0
    && allowedCodes.includes(code as LocalApiErrorCode);
}

function isModelBindingValidationError(error: HttpErrorResponse): boolean {
  const payload = error.error as {status?: unknown; errors?: unknown};
  return error.status === 400 && payload.status === 400 && !!payload.errors
    && typeof payload.errors === 'object' && !Array.isArray(payload.errors)
    && Object.keys(payload.errors).length > 0;
}
